import { PlusOutlined } from '@ant-design/icons'
import UploadAreaModal from '@common/Case/UploadAreaModal'
import UploadModal from '@common/Case/UploadModal'
import { toJS } from 'mobx'
import { inject, observer } from 'mobx-react'
import React from 'react'
import { KIND } from '../../constants'
import {
  formatDesignImage,
  formatSiteImage,
  unFormatSiteImage
} from '../../utils'
import style from './style.module.less'

const EditArea = ({ contentStore }) => {
  const {
    setActive,
    list,
    showAreaRef,
    getDesignImageLength,
    siteVisible,
    setSiteVisible,
    designVisible,
    setDesignVisible,
    getStageCeremonyImages,
    getSignImages,
    getWeddingDetailImages,
    getNoSettingImages,
    getSiteImageLength
  } = contentStore

  // 添加设计稿
  const designOnSave = e => {
    const images = formatDesignImage(e)
    setDesignVisible(false)
    if (!images.length) {
      const delIndex = list.findIndex(f => f?.kind === KIND['DesignDiagram'])
      list.splice(delIndex, 1, undefined)
      return
    }
    list[KIND['DesignDiagram'] - 1] = {
      kind: KIND['DesignDiagram'],
      imgs: images
    }
  }

  // 添加现场图
  const areaOnSave = e => {
    const data = unFormatSiteImage(e)
    const { check, detail, stage, unsign } = data
    list[KIND['StageCeremony'] - 1].imgs = stage?.imgs
    list[KIND['WelcomeSign'] - 1].imgs = check?.imgs
    list[KIND['WeddingDetail'] - 1].imgs = detail?.imgs
    list[KIND['NoSetting'] - 1].imgs = unsign?.imgs
    setSiteVisible(false)
  }

  // 添加设计构思
  const addDesignConcept = e => {
    e.stopPropagation()
    if (list.findIndex(f => f?.kind === KIND['DesignConcept']) === -1) {
      list.splice(KIND['DesignConcept'] - 1, 1, {
        kind: KIND['DesignConcept'],
        text: ''
      })
    }
    showAreaRef.current.scrollTop = 0
    setActive(KIND['DesignConcept'])
  }

  return (
    <div className={style.editArea}>
      <div className={style.wrapper}>
        <div className={style.title}>
          <span>图文介绍</span>
        </div>
        <div className={style.addArea}>
          <ul>
            <li onClick={() => setSiteVisible(true)} className={style.item}>
              <PlusOutlined style={{ color: '#448AFC', fontSize: 16 }} />
              <span>上传现场图({getSiteImageLength}/50)</span>
            </li>
            <li onClick={() => setDesignVisible(true)} className={style.item}>
              <PlusOutlined style={{ color: '#448AFC', fontSize: 16 }} />
              <span>上传设计稿({getDesignImageLength}/9)</span>
            </li>
            <li onClick={addDesignConcept} className={style.item}>
              <PlusOutlined style={{ color: '#448AFC', fontSize: 16 }} />
              <span>添加设计构思</span>
            </li>
          </ul>
          <div className={style.tip}>
            <p>1. 图片至少上传 5 张，最多 50 张；</p>
            <p>
              2. 图片高度在 8192px 以下，大小不能超过 10 MB，支持
              JPG、PNG、BMP等格式。
            </p>
          </div>
        </div>
        <UploadModal
          visible={designVisible}
          max={9} // 允许上传最大数目
          initValue={toJS(list[0]?.imgs)}
          onSave={designOnSave}
          onCancel={() => {
            setDesignVisible(false)
          }}
        />
        <UploadAreaModal
          initValue={formatSiteImage(
            getNoSettingImages,
            getStageCeremonyImages,
            getSignImages,
            getWeddingDetailImages
          )}
          max={50} // 允许上传最大数目
          visible={siteVisible}
          onSave={areaOnSave}
          onCancel={() => {
            setSiteVisible(false)
          }}
        />
      </div>
    </div>
  )
}

export default inject('contentStore')(observer(EditArea))
